import React, { useCallback } from "react";

import { faCircle } from "@fortawesome/pro-regular-svg-icons";
import { faCircleCheck } from "@fortawesome/pro-solid-svg-icons";
import { faChevronRight } from "@fortawesome/pro-solid-svg-icons/faChevronRight";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cn from "classnames";

import styles from "./ChecklistItem.module.scss";
import ChecklistItemType from "./types/ChecklistItemType";

export interface ChecklistItemProps {
  complete?: boolean;
  item: ChecklistItemType;
  onClick?: (itemId: ChecklistItemType["id"]) => void;
}

const ChecklistItem = ({ complete, item, onClick }: ChecklistItemProps) => {
  const handleClick = useCallback(() => {
    onClick?.(item.id);
    item.onClick?.(item.id);
  }, [item, onClick]);

  return (
    <div className={styles.container} onClick={handleClick}>
      <div className={styles.header}>
        <div className={styles.title}>
          <FontAwesomeIcon
            className={cn(styles.icon, { [styles.complete]: complete })}
            icon={complete ? faCircleCheck : faCircle}
          />
          {item.title}
        </div>
        {item.info && <div className={styles.info}>{item.info}</div>}
      </div>
      <FontAwesomeIcon className={styles.chevron} icon={faChevronRight} />
    </div>
  );
};

export default ChecklistItem;
